import Footer from "../../../../Components/Footer";
import Header from "../../../../Components/Header";
import MainContent from "./MainContent";
import { Helmet } from "react-helmet";

const GRN = () => {
    return (
      <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
        <title>GRN List</title>
      </Helmet>
      <Header />
      <MainContent />
      {/* <Footer /> */}
      </div>
    );
  };
  
  export default GRN;